<template>
  <button
    v-if="player.hearingImpairedTrack.value"
    class="control-button"
    :class="{ 'control-button--active': isActive }"
    :aria-label="isActive ? t('player.controls.hearingImpairedOn') : t('player.controls.hearingImpairedOff')"
    :aria-pressed="isActive"
    :data-tooltip="isActive ? t('player.controls.hearingImpairedOn') : t('player.controls.hearingImpairedOff')"
    @click="player.toggleHearingImpairedTrack()"
    v-html="hearingIcon"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { hearingIcon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'

const props = defineProps<{
  player: UseVideoPlayerReturn
}>()

const { t } = useVideoI18n()

const isActive = computed(
  () =>
    !!props.player.hearingImpairedTrack.value &&
    props.player.currentAudioTrackIndex.value === props.player.hearingImpairedTrack.value.index,
)
</script>

<style scoped>
.control-button--active {
  background: var(--vp-primary-color, #007bff) !important;
  color: var(--vp-primary-ink, #fff) !important;
}
</style>
